/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { func, object, string } from 'prop-types';
import AgeZipVerification from './AgeZipVerification';
import SubscriptionRecipientFormDialog from '../../Subscriptions/SubscriptionRecipientForm/SubscriptionRecipientFormDialog';
import findSkuByPartNumbers from '../../../../../gql/queries/findSkuByPartNumbers';

const RecipientDialog = ({
    ruleId,
    selectedSubscription,
    recipientData,
    customerId,
    updateSubscriptionReduxList,
    featureFlags,
    validatedZip,
    toggleForm,
    closeClick,
}) => {
    if (toggleForm !== 'Recipient') return null;
    const [mobileAgeVerificationOpen, setMobileAgeVerificationOpen] = useState(false);
    const brandByDomain = {
        1001: '1800flowers',
        1019: 'harryanddavid',
        1009: '1800baskets',
        1025: 'simplychocolate',
        1010: 'fruitbouquets',
        1012: 'cheryls',
        1022: 'personalizationuniverse',
        1002: 'thepopcornfactory',
        1020: 'wolfermans',
        1018: 'stockyards',
        1030: 'personalizationmall',
        1031: 'vitalchoice',
        1033: 'thingsremembered',
        1034: 'florists',
    };

    const QUERY = findSkuByPartNumbers(
        brandByDomain[selectedSubscription?.brand],
        `["${selectedSubscription?.brand}-${selectedSubscription?.productId}"]`,
        `id
        name
        brand
        brandId
        baseCode
        partNumber
        productType
        minAge
        ageVerifyFlag
        parentProduct {
          partNumber
          name
        }`,
    );
    const { data } = useQuery(QUERY);
    const selectedSku = data?.findSkuByPartNumbers?.[0] || {};

    const handleMobileAgeVerification = (flag) => {
        setMobileAgeVerificationOpen(flag);
    };
    let validZip = '';

    // ageVerifyFlag coming in aggregator call is not boolean value
    if (featureFlags['is-ws-age-verification-enabled'] && selectedSku?.ageVerifyFlag === 'true') {
        setMobileAgeVerificationOpen(true);
        validZip = validatedZip;
    }

    return (
        <div>
            <SubscriptionRecipientFormDialog
                validZip={validZip}
                ruleId={ruleId}
                handleRecipientSubmit={() => {}} // TO DO: remove it, as not needed for new UI
                selectedSubscription={selectedSubscription}
                orderItemId={selectedSubscription.productId}
                closeClick={closeClick}
                isOpen={toggleForm}
                recipientData={recipientData}
                customerId={customerId}
                updateSubscriptionReduxList={updateSubscriptionReduxList}
            />
            <AgeZipVerification
                selectedSku={selectedSku}
                selectedSubscription={selectedSubscription}
                mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                handleMobileAgeVerification={handleMobileAgeVerification}
                openRecipientModal={toggleForm}
            />
        </div>
    );
};

RecipientDialog.propTypes = {
    ruleId: string.isRequired,
    selectedSubscription: object.isRequired,
    recipientData: object.isRequired,
    customerId: string.isRequired,
    updateSubscriptionReduxList: func.isRequired,
    featureFlags: object.isRequired,
    validatedZip: string.isRequired,
    toggleForm: string.isRequired,
    closeClick: func.isRequired,
};

export default RecipientDialog;
